<template>
    <timecard-dialog v-if="model.id && $store.getters.checkModulePermissions('timecards')"
        :default-input="{entity: modelDef+'_'+model.id}"
        :params="params"
        :model="model"
        :button="button"
        :button-component="buttonComponent"
    ></timecard-dialog>
</template>

<script>
    import TimecardDialog from '@/components/common/TimecardDialog'

    export default {
        name: 'timecard-button-component',
        components: {
            TimecardDialog
        },
        props: {
            button: Object,
            modelDef: String,
            params: Object,
            model: Object,
            buttonComponent: String,
        },
    }
</script>